import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const Button = props => {
    const { variant, text, icon, className, disabled, onClick } = props

    const handleClick = event => {
        if (disabled) {
            event.preventDefault()
            event.stopPropagation()
        } else if (onClick) {
            onClick(event)
        }
    }

    return (
        <button
            {...props}
            onClick={handleClick}
            disabled={disabled}
            className={clsx(className, variant, {
                'cursor-not-allowed opacity-50': disabled,
            })}
        >
            {icon && icon}
            {text}
        </button>
    )
}

Button.propTypes = {
    variant: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.node,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
}

export default Button
